export enum ExportType {
  Excel = "Excel",
  Text = "Text",
  XML = "XML",
  JSON = "JSON",
  BMEcat = "BMEcat",
  BMEcat2005 = "BMEcat2005",
  BMEcatETIM2005 = "BMEcatETIM2005",
  TradeProNext = "TradeProNext",
  FastPage = "FastPage",
  Ariba = "Ariba"
}

export enum ExportSettingItem {
  Catalogue = "catalogue",
  Supplier = "supplier",
  Buyer = "buyer",
  Agreements = "agreements",
  UdxList = "udxList",
  Upload = "upload",
  Update = "update",
  Placeholders = "placeholders",
  Layouts = "layouts"
}

export enum LayoutFileType {
  Label = "ll/project/lbl",
  List = "ll/project/lst",
  Card = "ll/project/crd"
}

export enum AdditionalLayoutFileType {
  TableOfContent = "ll/project/toc",
  Index = "ll/project/idx"
}

export enum LayoutFolderType {
  Folder = "repos/folder"
}

export enum LayoutTypeLabel {
  "" = "",
  "ll/project/lbl" = "Label",
  "ll/project/lst" = "List",
  "ll/project/crd" = "Card",
  "ll/project/toc" = "TableofContent",
  "ll/project/idx" = "Index",
  "resource/image" = "Image",
  "resource/pdf" = "PDF",
  "ll/project/gtc" = "ProjectReverseSide",
  "ll/printerconfig" = "PrinterConfig",
  "ll/sketch" = "SketchImage",
  "resource/shapefile" = "Shapefile",
  "resource/shapefile/database" = "ShapefileDatabase",
  "repos/folder" = "Folder"
}
